import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled, { keyframes } from 'styled-components';
const Dot = styled.div.withConfig({ displayName: "brc-Dot", componentId: "brc-1qr63nz" }) `
  margin: 0.25em 0.3em;
  border-radius: 50%;
  height: 0.5em;
  width: 0.5em;
`;
const fadeIn = keyframes `
  from { opacity: 1; }
  to { opacity: 0; }
`;
const Dot1 = styled(Dot).withConfig({ displayName: "brc-Dot1", componentId: "brc-nofaqj" }) `
  animation: ${fadeIn} 1.5s ease infinite;
`;
const Dot2 = styled(Dot).withConfig({ displayName: "brc-Dot2", componentId: "brc-lp024i" }) `
  animation: ${fadeIn} 1.5s ease 0.15s infinite;
`;
const Dot3 = styled(Dot).withConfig({ displayName: "brc-Dot3", componentId: "brc-1gvccyn" }) `
  animation: ${fadeIn} 1.5s ease 0.3s infinite;
`;
export const Wrapper = styled.div.withConfig({ displayName: "brc-Wrapper", componentId: "brc-ce7vww" }) `
  display: flex;

  & > * {
    background-color: currentcolor;
  }
`;
export const LoadingDots = (props) => (_jsxs(Wrapper, Object.assign({}, props, { children: [_jsx(Dot1, {}), _jsx(Dot2, {}), _jsx(Dot3, {})] })));
const StyledLoadingDots = styled(LoadingDots).withConfig({ displayName: "brc-StyledLoadingDots", componentId: "brc-1o7b022" }) ``;
export default StyledLoadingDots;
//# sourceMappingURL=loading-dots.js.map